import { render, staticRenderFns } from "./asinfo.vue?vue&type=template&id=2a71e1e2&scoped=true"
import script from "./asinfo.vue?vue&type=script&lang=js"
export * from "./asinfo.vue?vue&type=script&lang=js"
import style0 from "./asinfo.vue?vue&type=style&index=0&id=2a71e1e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a71e1e2",
  null
  
)

export default component.exports